const HOME_PAGE = "nexgen home page";
const LOGIN_PAGE = "nexgen login page";
const SEARCH_PAGE = "nexgen search page";
const OFFERS_PAGE = "nexgen offers page";
const LOCATION_PAGE = "nexgen location page";
const PROFILE_PAGE = "nexgen profile page";
const FAVOURITE_PAGE = "nexgen favourite page";
const ORDERHISTORY_PAGE = "nexgen order history page";
const ADDRESSES_PAGE = "nexgen addresses page";
const CUSTOMISATION_PAGE = "nexgen customisation page";
const SEARCH_CUSTOMISATION_PAGE = "nexgen search customisation page";
const NON_CUSTOMISATION_PAGE = "nexgen non customisation page";
const SEARCH_NON_CUSTOMISATION_PAGE =
  "nexgen search non customisation page";
const CART_PAGE = "nexgen cart page";
const MENU_PAGE = "nexgen menu page";
const ABOUT_US_PAGE = "nexgen about us page";
const NUTRITIONAL_INFO_PAGE = "nexgen nutritional info page";
const CONTACT_US_PAGE = "nexgen contact us page";
const PRIVACY_POLICY_PAGE = "nexgen privacy policy page";
const BLOGS_PAGE = "nexgen blogs page";

const getPageNameFromPathName = () => {
  const page = window.location.pathname
    ?.trim()
    ?.replace(/^\/+/, "")
    ?.replace(/\/+$/, "");

  if (page.endsWith("cart")) {
    return CART_PAGE;
  }
  if (page.endsWith("search")) {
    return SEARCH_PAGE;
  }
  if (page.endsWith("login")) {
    return LOGIN_PAGE;
  }
  if (page.endsWith("offers")) {
    return OFFERS_PAGE;
  }
  if (page.endsWith("location")) {
    return LOCATION_PAGE;
  }
  if (page.endsWith("my-profile")) {
    return PROFILE_PAGE;
  }
  if (page.endsWith("my-favourites")) {
    return FAVOURITE_PAGE;
  }
  if (page.endsWith("order-history")) {
    return ORDERHISTORY_PAGE;
  }
  if (page.endsWith("my-addresses")) {
    return ADDRESSES_PAGE;
  }
  if (page.endsWith("menu")) {
    return MENU_PAGE;
  }
  if (page.endsWith("about-us")) {
    return ABOUT_US_PAGE;
  }
  if (page.endsWith("nutritional-info")) {
    return NUTRITIONAL_INFO_PAGE;
  }
  if (page.endsWith("contact-us")) {
    return CONTACT_US_PAGE;
  }
  if (page.endsWith("privacy-policy")) {
    return PRIVACY_POLICY_PAGE;
  }
  if (page.includes("blog")) {
    return page.split('/blog/')[1] || BLOGS_PAGE
  }

  return HOME_PAGE;
};

export default {
  HOME_PAGE,
  LOGIN_PAGE,
  OFFERS_PAGE,
  SEARCH_PAGE,
  LOCATION_PAGE,
  CUSTOMISATION_PAGE,
  SEARCH_CUSTOMISATION_PAGE,
  NON_CUSTOMISATION_PAGE,
  SEARCH_NON_CUSTOMISATION_PAGE,
  CART_PAGE,
  MENU_PAGE,
  PROFILE_PAGE,
  FAVOURITE_PAGE,
  ORDERHISTORY_PAGE,
  ADDRESSES_PAGE,
  NUTRITIONAL_INFO_PAGE,
  ABOUT_US_PAGE,
  CONTACT_US_PAGE,
  PRIVACY_POLICY_PAGE,
  BLOGS_PAGE,
  getPageNameFromPathName,
};
